import type { IconSvgObject } from './types';

const Recycle03Icon: IconSvgObject = [
  ["path", { d: "M6 2.5L9 3.72302L8 6.5M22 14.5L19.0645 16.5L17.5 13.5M7 17.5H3.51555V21M17 19.2083C15.4077 20.6334 13.3051 21.5 11 21.5C8.25091 21.5 5.7897 20.2674 4.13885 18.3248M12.5 3.62444C16.7566 4.33855 20 8.04051 20 12.5C20 13.5786 19.8103 14.6128 19.4624 15.5712M2.12444 14C2.0426 13.5122 2 13.0111 2 12.5C2 8.58134 4.50442 5.24763 8 4.01212", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Recycle03Icon;
